export default "https://client.chat.ao.com/1289/beta/without-externals/assets/images/no-image.png?42154efae9acc9fbe1b56ddf47d2e264";